import { Getter } from "vuex";
import { IState } from './state';

export default {
}
